import { NgTemplateOutlet } from "@angular/common"
import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { reportParamsObj } from "@app/definitions/types"
import { taxesList } from "@app/definitions/types"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { InArrayPipe } from "@app/utils/in-array.pipe"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-taxes-report",
	imports: [
		COMMON_IMPORTS,
		ModalWrapComponent,
		NgTemplateOutlet,
		LangValPipe,
		GenButtonGroupComponent,
		GenSelectComponent,
		DatePickerComponent,
		DateFormatPipe,
		InArrayPipe,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./taxes-report.component.html",
})
export class TaxesReportComponent extends Modalable {
	taxes: taxesList //the taxes data
	periodInputs: string[] = [
		"this_year",
		"last_year",
		"this_month",
		"month_before",
		"two_months_before",
		"date_range",
	] //the periods of time available
	reportParamsObj: reportParamsObj = new reportParamsObj() //the report params to be sent to api and changed by the fields
	numberFormatObj = new Intl.NumberFormat("he-IL", { maximumFractionDigits: 2 }) //used to format numbers (commas and decimal)
	taxesReportMode: any = "taxes"
	errors: any = {} //will hold errors for the fields in the form

	vat_numbers: any[] = []
	is_new_vat_number: boolean = false

	fields: any[] = [
		//the columns to display
		{
			fieldName: "total_invoice_total_with_vat",
			lang: "total_invoice_total_with_vat",
		},
		{
			fieldName: "total_invoice_total_without_vat",
			lang: "total_invoice_total_without_vat",
		},
		{ fieldName: "total_tax_downpayment", lang: "total_tax_downpayment" },
		{ fieldName: "total_invoice_vat", lang: "total_invoice_vat" },
		//{ fieldName:'total_expenses', lang: 'total_expenses' },
		{
			fieldName: "total_expense_vat_recognized",
			lang: "total_expense_vat_recognized",
		},
		//	{ fieldName:'total_expense_recognized', lang: 'total_expense_recognized' },
		//{ fieldName:'total_expense_tax_not_permanent', lang: 'total_expense_tax' },
	]

	ngOnInit() {
		//when called to open reset the params object, dates and get the info
		this.reportParamsObj = new reportParamsObj()
		this.reportParamsObj.from_date = this.store.getDateStr()
		this.reportParamsObj.to_date = this.store.getDateStr(true)
		this.reportParamsObj.showByCreatedAt = "yes"
		this.updateDisplayDates()
		this.getResults()
		this.taxesReportMode = "taxes"
		this.vat_numbers = []
		this.is_new_vat_number = false

		const cliniqData = this.store.cc()

		if (cliniqData.is_new_vat_number == "yes") {
			this.is_new_vat_number = true
			this.vat_numbers = [
				{ id: "", name: this.lang.getVal("all_vat_numbers") },
				{ id: cliniqData.old_vat_number, name: cliniqData.old_vat_number },
				{ id: cliniqData.vat_number, name: cliniqData.vat_number },
			]
		}
	}

	updateDisplayDates() {
		//update the dates display according to the period
		if (this.reportParamsObj.report_period_input == "date_range") {
			//in date range - get the times from the inputs
			return
		}
		const [from, to] = this.store.getPriodFromTo(
			this.reportParamsObj.report_period_input
		)
		this.reportParamsObj.from_date = from
		this.reportParamsObj.to_date = to
		this.reportParamsObj.taxesReportMode = this.taxesReportMode
	}

	onDateChange(fieldName: string) {
		//date changed - update the display dates and get new data from api
		this.updateDisplayDates()
		this.getResults()
	}

	changeBtn(fieldName: string, value: string) {
		//change period = update display dates and get new data from api
		this.reportParamsObj[fieldName] = value
		this.updateDisplayDates()
		this.getResults()
	}

	async getResults() {
		//get data from api    //COME BACK TO TYPE!!!!
		const res: any = await this.apiService.post(
			"get_taxes_report",
			this.reportParamsObj
		)
		this.taxes = res
		for (let key of Object.keys(this.taxes)) {
			if (key != "message" && key != "tax_percent_text") {
				this.taxes[key] = this.numberFormatObj.format(this.taxes[key])
			}
		}

		/*let disaplyArray: any[] = [];

    let arrFieldsToFormat = [];
    this.fields.forEach(field => {

      if (field.isNumberField) {
        arrFieldsToFormat.push(field.fieldName);
      }
    });
    */
	}

	async downloadReport() {
		//request to download report from api
		this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download("get_taxes_report", {
				...this.reportParamsObj,
				dlExcel: true,
			})
			this.apiService.downloadFile(res, "report.xlsx")
		})
	}
  async getPcn874() {
		//request to download report from api
		this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download("get_pcn874_report", {
				...this.reportParamsObj,
				pcn874: true,
			})
			this.apiService.downloadFile(res, "report.xlsx")
		})
	}

	async print() {
		//print this report by creating a new document, opening it, and requesting the winodw to print

		let html = document.getElementById("section-to-print")?.innerHTML
		this.store.printWindow(`
		<html>
		<style type='text/css'>${this.store.getPrintStyle()}</style>
		<body onload="window.print()" style="direction:rtl">
		${html}
		</body>
		</html>`)
	}
}
